import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { IMGIX_URL } from '@src/env';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import Stats from './Stats';

const Awards = () => {
  const { trackEvent } = useEventTracking({ location: TrackingLocation.Awards });

  const handleBackToTopClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.BackToTop }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="mt-64 flex flex-col items-center justify-center px-16 sm:mt-96">
      <div className="flex justify-center gap-32 sm:gap-48">
        <LogoTIWithIconTI className="w-[148px] text-black sm:w-[253px]" />
        <LazyImgixImage
          className="h-full w-full"
          alt="SABEW best in business awards"
          src={`${IMGIX_URL}/global/subscribe/best_in_business.png`}
          wrapperClassName="rounded-full w-[80px] h-[80px] sm:h-[110px] sm:w-[110px] shrink-0"
        />
      </div>
      <h2 className="mb-0 mt-32 text-center font-suisse-works text-headline-xxs text-black sm:mt-48 sm:text-headline-md">
        Winner of the Best in Business journalism awards
      </h2>
      <div className="mt-32 flex items-center justify-center sm:mt-48">
        <Stats text="Wins" value={5} />
        <div className="mx-16 h-[40px] rotate-[25deg] border-0 border-r border-solid border-grayscale-gray sm:mx-48 sm:h-[90px]" />
        <Stats text="Honorable Mentions" value={2} />
      </div>
      <PrimaryButton
        as="button"
        onClick={handleBackToTopClick}
        size="small"
        className="mt-48 w-full sm:mt-64 sm:w-[496px]"
      >
        Back to top
      </PrimaryButton>
    </div>
  );
};

export default Awards;
